import React from 'react';
import {Checkbox} from '@mui/material';

export const icon = <Checkbox size='small' />;
export const checkedIcon = <Checkbox size='small' checked />;

export interface SelectDropdownRenderOptionProps<T> {
  selectAll?: boolean;
  SELECT_ALL_ID?: T;
  getFilteredOptions?: () => T[];
  handleSelectAll?: (event: React.MouseEvent) => void;
  selecteValues: (string | number)[];
  option: T;
  props: React.HTMLAttributes<HTMLLIElement>;
  getOptionLabel?: (option: T) => string;
}

export function SelectDropdownRenderOptions<T = string | number>({
  selectAll = true,
  SELECT_ALL_ID = 0 as T,
  getFilteredOptions,
  handleSelectAll,
  selecteValues,
  option,
  props,
  getOptionLabel,
}: SelectDropdownRenderOptionProps<T>) {
  if (selectAll && option === SELECT_ALL_ID) {
    const {onClick, ...otherProps} = props;
    const filteredOptions = getFilteredOptions ? getFilteredOptions() : [];
    const getComparableValue = (opt: T) =>
      typeof opt === 'object' && getOptionLabel ? getOptionLabel(opt) : opt;

    const allFilteredSelected = filteredOptions.every(opt =>
      selecteValues.includes(getComparableValue(opt) as string | number)
    );
    const someFilteredSelected = filteredOptions.some(opt =>
      selecteValues.includes(getComparableValue(opt) as string | number)
    );
    return (
      <li
        {...otherProps}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          handleSelectAll && handleSelectAll(e);
        }}
        key="select-all"
        style={{cursor: 'pointer'}}
      >
        <Checkbox
          icon={icon}
          checkedIcon={checkedIcon}
          style={{marginRight: 8}}
          checked={allFilteredSelected && filteredOptions.length > 0}
          indeterminate={someFilteredSelected && !allFilteredSelected}
        />
        {'Select All'}
      </li>
    );
  }

  // Render regular option
  return (
    <li {...props}>
      <Checkbox
        icon={icon}
        checkedIcon={checkedIcon}
        style={{marginRight: 8}}
        checked={selecteValues.includes(
          (typeof option === 'object' && getOptionLabel ? getOptionLabel(option) : option) as string | number
        )}
      />
      {typeof option === 'object' && getOptionLabel ? getOptionLabel(option) : option}
    </li>
  );
}
